// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"65":"8fc93ad2fe","88":"5fb25a2f2a","278":"e7591bd110","427":"91885c3a3b","565":"58c0a24554","983":"bbd55a50f5"}[chunkId] + ".css";
};